<template>
  <div class="protocol login-protocol">
    <navigation>《会员礼包服务协议》</navigation> 
    <section class="content">
      <p class="text tab-2"><b>《会员礼包服务协议》（下称“本协议”）由您（下称“用户”或“您”）与会员礼包服务的运营商重庆领易付科技有限公司（下称“领易付”）进行缔结，对双方均具有同等法律效力。领易付建议您仔细阅读本协议的全部内容，尤其是以加粗形式展示的，与您的权利（可能）存在重大关系的条款（包括相关约定领易付责任、您享有的权利、信息授权、争议解决方式及司法管辖等条款），请您重点阅读。若您认为本协议中的条款可能导致您的部分或全部权利或利益受损，请您务必再次仔细阅读，在确保您已经理解、接受相关条款的前提下，继续使用会员礼包服务。</b></p>
      <p class="text tab-2"><b>如您不同意本协议的任一/全部条款内容，请不要以确认形式（包括但不限于点击确认“同意并继续”、电子签名、支付行为、或完成接受会员礼包服务的全部程序而在此过程中未向领易付或平台提出关于本协议的任何异议）进行下一步操作或使用会员礼包服务。当您以确认形式进行下一步操作或使用会员礼包服务时，即表示您已与领易付达成协议关系，您自愿接受本协议并遵守本协议项下的全部约定。</b></p>
      <p class="text tab-2"><b>一、服务说明 </b></p>
      <p class="text tab-2">1.1平台：指由重庆市崇天小额贷款有限公司及其关联公司共同运营的天美贷网站、小程序、移动客户端以及以其他形式提供的操作环境，运营商通过平台向用户展示会员礼包相关内容。</p>
      <p class="text tab-2">1.2用户：指平台注册用户，用户经领易付审核且资格通过后可购买会员礼包。</p>
      <p class="text tab-2">1.3会员礼包：指为用户打造的付费权益服务礼包，礼包中包含由领易付及领易付的合作服务方共同为用户提供的各类服务内容。</p>
      <p class="text tab-2">1.4合作服务方：指与领易付合作，为用户提供包括但不限于支付转账、消费、娱乐、资讯、交通出行、生活服务等各类服务的主体。合作服务方与用户之间的服务条款请参考附件一：《岫智生活权益平台权益服务协议》。</p>
      <p class="text tab-2"><b>二、协议的签署和修订</b></p>
      <p class="text tab-2">2.1<b>您通过点击确认“同意并继续”、勾选、提交、电子签名等任一方式确认/签署协议或您进行支付行为、完成接受会员礼包服务的全部程序而在此过程中没有提出任何异议即视为您已与领易付达成协议关系，您自愿接受协议约束，且同意按本协议内容履行。因您违反协议、使用规则等导致的一切法律后果，您同意承担相应法律责任。</b></p>
      <p class="text tab-2">2.2根据国家法律法规变化及运营需要，领易付有权以公告的方式进行不定期地制定、修改本协议及/或相关服务规则，暂停、取消和修改本协议条款，<b>修改后的协议一旦被公告在平台上即生效，并代替原来的协议。</b>您应及时关注不时发布的各项服务规则及本协议的变更。若不同意相关规则及条款修改的，应及时终止与领易付的协议。如您继续使用领易付提供的服务的，即视为同意更新后的协议。领易付建议您在使用服务之前阅读本协议及相关公告。</p>
      <p class="text tab-2">2.3<b>平台相关系统所生成和保留记载的相关电子数据、交易记录、日志等资料均构成您确认/签署、履行本协议相关事项的有效证明。</b></p>
      <p class="text tab-2">2.4<b>您应确认在您开始使用会员礼包服务前，您已具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。</b></p>
      <p class="text tab-2"><b>三、会员礼包服务及相关</b></p>
      <p class="text tab-2"><b>3.1 会员礼包服务内容</b></p>
      <p class="text tab-2">会员礼包，包括支付转账、消费、娱乐、资讯、交通出行、生活服务等各类服务，<b>具体以会员礼包服务购买页面说明或领易付及其合作服务方实际提供为准</b>。您购买会员礼包后，即可享受礼包内包含的各项服务，您可在礼包有效期内选择其中的一项或多项进行兑换使用。</p>
      <p class="text tab-2"><b>3.2关于会员礼包的特别说明</b></p>
      <p class="text tab-2">（1）会员礼包中各项具体服务内容由领易付或领易付的合作服务方提供。如用户希望使用由合作服务方提供的某项具体服务内容的，<b>用户需要另行在合作服务方平台进行兑换和使用，如兑换使用时需支付相关费用，将由用户自行支付（例如：会员礼包中含某视频影音平台VIP会员5折券，券后费用仍需用户自行支付）。</b>用户需遵循合作服务方的平台使用规则。</p>
      <p class="text tab-2"><b>请您知悉，领易付及平台均不对合作服务方提供的服务内容及您与合作服务方的交易承担任何责任</b>，但如发生争议，领易付会在合理范围内协助您与合作服务方协商沟通。</p>
      <p class="text tab-2">（2）为更好的向您提供服务，领易付有权基于法律法规及监管政策变更、运营策略调整、业务发展计划变更、用户需求等因素对会员礼包的部分或全部内容进行调整（包括但不限于变更、增加、减少、优化部分会员礼包内容及/或服务类型，调整、优化部分产品功能等）。就前述调整领易付将在相应服务页面或以其他合理的方式进行通知或公告，建议您及时通过平台或本页面查询并仔细阅读最新的服务内容；同时，领易付也将尽量降低前述调整对您既有的服务内容的影响。</p>
      <p class="text tab-2"><b>3.3服务期限</b></p>
      <p class="text tab-2">当您购买会员礼包服务后，系统即自动为您提供各项权益服务，用户应在购买时所展示的对应服务期限内（有效期）使用。具体以会员礼包的体验、购买流程为准。<b>请您特别注意，有效期届满后无论您是否使用完毕服务内容，您已支付的费用将不予退还。</b></p>
      <p class="text tab-2">领易付特别提示您，部分会员礼包服务内容在您付费成功后有一定的使用有效期（具体以购买页面说明为准），请您记得及时使用。</p>
      <p class="text tab-2"><b>四、费用收取及退还</b></p>
      <p class="text tab-2"><b>4.1 收费方式</b></p>
      <p class="text tab-2">本协议项下会员礼包服务为收费服务，您可通过平台公示或平台实际支持的支付方式购买会员礼包，包括但不限于：</p>
      <p class="text tab-2">（1）通过领易付合作的第三方支付机构（宝付网络科技（上海）有限公司等）提供的第三方支付方式进行支付。</p>
      <p class="text tab-2">（2）通过领易付的合作公司提供的第三方支付方式（如有）进行支付。</p>
      <p class="text tab-2"><b>4.2 费用支付周期</b></p>
      <p class="text tab-2">针对用户购买会员礼包需支付的礼包费用，领易付根据礼包所涉服务内容向用户提供不同的支付周期，具体以平台服务页面展示为准：</p>
      <p class="text tab-2">（1）一次性支付：付款成功即为有效购买，会员礼包的相关服务内容将在有效购买后自动开通。</p>
      <p class="text tab-2">（2）分期支付：针对会员礼包费用的消费分期订单生成即为有效购买（消费分期订单生成规则以相关服务页面公示内容为准），会员礼包相关服务内容将在有效购买后自动开通，用户应当按照前述消费分期订单显示的信息按时或提前完成前述消费分期订单的支付。</p>
      <p class="text tab-2"><b>4.3 费用退还</b></p>
      <p class="text tab-2"><b>会员礼包服务系网络商品和虚拟商品，会员费用是您所购买的会员礼包服务所对应的网络商品价格，而非预付款或者存款、定金、储蓄卡等性质，会员礼包服务一经购买后原则上不予退款。</b>请您在确认购买本协议所涉会员礼包服务前仔细阅读协议内容、购买详情页说明等信息。</p>
      <p class="text tab-2"><b>4.4 收费标准、方式的变更</b></p>
      <p class="text tab-2"><b>会员礼包服务的收费标准、收费方式由领易付根据公司的运营成本、合作服务方的运营成本等综合考虑后决定（调整包括但不限于促销、涨价等），并在相关的详情页及支付页面向您展示。若您在购买时，相关收费标准或方式发生变更的，请以实际发生为准。</b></p>
      <p class="text tab-2"><b>五、用户行为规范和违约处理</b></p>
      <p class="text tab-2">5.1 在您使用会员礼包服务的过程中，不得存在以下行为：</p>
      <p class="text tab-2">（1）通过技术手段对服务内容、服务期限、服务费用等信息进行修改；</p>
      <p class="text tab-2">（2）将平台账户赠与、出借、转让、出售、抵押、继承、许可他人使用；</p>
      <p class="text tab-2">（3）除为实现用户自身的会员礼包权益外，利用会员礼包服务非法获利，滥用其所享有的权益；</p>
      <p class="text tab-2">（4）其他违反本协议、法律法规或监管政策、侵犯第三方或领易付合法权益的行为。</p>
      <p class="text tab-2">5.2 您知悉并同意，如您存在上述不当行为或任何违反国家法律法规或监管政策、违反本协议或有损领易付及/或其关联公司的声誉、利益的行为的，领易付有权采取以下一项或多项处理措施：</p>
      <p class="text tab-2">（1）如本协议或相关协议文本对该行为有单独条款约定处理方式的，按照该条款处理；</p>
      <p class="text tab-2">（2）暂停或关闭用户的会员礼包权益，且用户已支付的费用不予退还；用户尚未清偿完毕的礼包费用的消费分期订单应全部提前到期，用户应立即清偿该等消费分期订单项下的所有待支付款项。</p>
      <p class="text tab-2">（3）如您的行为致使领易付及/或合作服务方遭受任何损失的，您需承担全部损失赔偿责任并在领易付的要求的时限内完成费用支付。</p>
      <p class="text tab-2"><b>六、 用户信息收集、使用、加工、存储及保护</b></p>
      <p class="text tab-2"><b>6.1您有义务向领易付提供自己的真实资料，并保证诸如电子邮件地址、联系电话、联系地址、邮政编码等内容的有效性、安全性和及时更新，以便领易付为您提供服务并与您进行及时、有效的联系。</b></p>
      <p class="text tab-2"><b>6.2您同意领易付在提供会员礼包服务的过程中收集、使用和储存您的基础信息，包括但不限于您自行提供的信息、领易付依据您的授权从第三方平台收集的您的信息、领易付从公开渠道查询和收集的您的信息等，前述您的信息包括但不限于您的身份信息、平台账号信息、财产信息等。</b></p>
      <p class="text tab-2"><b>6.3您同意领易付在提供服务的过程中储存您的用户信息，包括但不限于您自行提供的资料和信息，以及领易付自行收集、取得的您在接受服务过程中的浏览记录、交易记录、交易文本等。领易付收集和储存您信息的主要目的在于提高为您提供服务的效率和质量。 </b></p>
      <p class="text tab-2"><b>6.4领易付对于您提供、经认证的或领易付自行收集到的用户信息将按照本协议及有关规则予以保护、使用或者披露。领易付将采用行业标准惯例以保护您的用户资料，但鉴于技术限制，领易付不能确保您的全部信息资料不会通过本协议中未列明的途径泄露出去。</b></p>
      <p class="text tab-2"><b>6.5领易付承诺，仅在您的授权范围内进行使用上述信息。领易付不会将您的个人信息转让、出售给任何公司、组织和个人，但以下情况除外：</b></p>
      <p class="text tab-2"><b>（1）事先获得您的同意或授权；</b></p>
      <p class="text tab-2"><b>（2）为了促成您向领易付发起的交易；</b></p>
      <p class="text tab-2"><b>（3）根据适用的法律法规、法律程序的要求或强制性的行政或司法要求。</b></p>
      <p class="text tab-2"><b>（4）符合与您签署的相关协议（包括在线签署的书面协议以及相应的平台规则）或其他的法律文件约定所提供。</b></p>
      <p class="text tab-2"><b>6.6若您使用领易付之外的第三方（如合作服务方等）所提供的其他服务的，您在此同意并授权本平台本着促成交易的目的将您的相关信息提供给相应的第三方。</b></p>
      <p class="text tab-2"><b>6.7 您通过平台选择跳转至会员礼包服务的界面时，同意并授权平台向领易付及领易付的合作服务方共享您的平台注册账户相关信息。</b></p>
      <p class="text tab-2"><b>七、通知</b></p>
      <p class="text tab-2">为便于您获知与本协议和会员礼包服务相关的协议，<b>您同意并授权领易付通过网页公示、页面提示、弹窗、消息通知、公众号通知、站内信、您预留的联系方式（如收集短信、电子邮件等）等一种或多种方式进行通知（包括但不限于发送会员礼包开通及礼包期限提醒信息等）。</b>此类通知的内容或将对您产生重大有利或不利影响，请您务必确保联系方式为有效并请及时关注相应通知。</p>
      <p class="text tab-2"><b>八、责任限制与免除</b></p>
      <p class="text tab-2">8.1 本协议项下服务的中断或终止包括如下情况：</p>
      <p class="text tab-2">（1）您主动提出要求的；</p>
      <p class="text tab-2">（2）您存在任何违反国家法律法规或监管政策、违反本协议或有损领易付及/或其关联公司的声誉、利益的行为的；</p>
      <p class="text tab-2">（3）领易付根据法律法规、监管政策的规定或有权机关的要求；</p>
      <p class="text tab-2">（4）平台为维护平台账户与系统安全等紧急情况之需要；</p>
      <p class="text tab-2">（5）因台风、地震、海啸、洪水、停电、雷电、罢工、骚乱、政府行为、司法行政命令、战争或恐怖袭击等不可抗力原因；</p>
      <p class="text tab-2">（6）因病毒、木马、恶意程序攻击、网络拥堵、系统不稳定、系统或设备故障、通讯故障、电力故障、电信设备故障、银行原因、第三方服务瑕疵、政府行为等原因。</p>
      <p class="text tab-2">（7）其他领易付及/或平台无法抗拒的情况。</p>
      <p class="text tab-2">8.2<b>因上述原因导致服务的中断或终止、或发生其他风险情形，不视为领易付违约，领易付不承担任何责任，且您同意领易付可以自行或通过第三方采取更正差错、暂停服务或其他适当纠正措施。</b></p>
      <p class="text tab-2"><b>九、法律适用和争议解决</b></p>
      <p class="text tab-2">9.1本协议是由您与领易付共同签订的，适用于您关于会员礼包的全部行为，领易付有最终的解释权。</p>
      <p class="text tab-2">9.2本协议不涉及您与其他用户之间以及因使用会员礼包服务而产生的法律关系及法律纠纷。但您在此同意将全面接受并履行与其他用户在以及使用会员礼包服务签订的任何电子法律文本，并承诺按照该法律文本享有和（或）放弃相应的权利、承担和（或）豁免相应的义务。</p>
      <p class="text tab-2">9.3如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，则应认为该条款可与本协议相分割，并可被尽可能接近各方意图的、能够保留本协议要求的经济目的的、有效的新条款所取代，而且，在此情况下，本协议的其他条款仍然完全有效并具有约束力。</p>
      <p class="text tab-2">9.4本协议及其修订的有效性、履行与本协议及其修订效力有关的所有事宜，将受中国大陆法律管辖，任何争议仅适用中国法律。</p>
      <p class="text tab-2">9.5<b>因本协议所引起的用户与平台、领易付的任何纠纷或争议，首先应友好协商解决，协商不成的，用户在此完全同意将纠纷或争议提交平台运营方所在地的人民法院诉讼解决。</b></p>
      <p class="text tab-2"><b>十、通知与送达</b></p>
      <p class="text tab-2">10.1 本协议履行期间，领易付可以通过电子方式或邮寄方式向您传递书面通知或诉讼文书（包括但不限于一审、二审、执行、仲裁文书），按照您在平台提供的通讯地址交邮后的第三个自然日即视为送达；书面通知的形式还包括领易付在服务页面的公告或信息推送、平台公告、向您发送电子邮件、站内信、手机短信等电子方式，在采用电子方式进行书面通知的情况下，公告/发送当日即视为送达。</p>
      <p class="text tab-2">10.2 领易付有权决定以前述任何一种或几种形式书面通知您。领易付以多种方式向您发送通知的，通知送达时间以最先送达的为准。</p>
      <p class="text tab-2">10.3 如您在平台登记的地址或联系方式有变更的，应当提前7日通知平台及领易付。否则，视为原地址或联系方式继续有效。领易付或司法机关按照原地址或联系方式向您送达书面通知的，不论是否经签收均视为有效送达。</p>
      <p class="text tab-2"><b>十一、协议变更与解除</b></p>
      <p class="text tab-2">11.1 <b>领易付有权根据业务变化情况单方修改本协议中与您有关的权利义务。一旦协议条款变更，领易付将在相关服务页面进行公示，除法律法规或监管规定另有强制性规定外，经修订的内容一经公示，立即生效。</b>如您不同意修改后的协议，则应当立即停止使用领易付提供的会员礼包服务；否则，将视为您同意并接受修改后的协议。我们提醒您注意，停止使用领易付提供的服务后，您在本协议更新前使用领易付提供的服务所负的债务将继续有效。</p>
      <p class="text tab-2">11.2 如发生下列情形之一的，领易付有权终止本协议：</p>
      <p class="text tab-2">（1）您主动注销平台账户。</p>
      <p class="text tab-2">（2）您的平台账户被注销。</p>
      <p class="text tab-2">（3）您冒用他人名义、盗用他人账户使用领易付提供的服务。</p>
      <p class="text tab-2">（4）您使用领易付提供的服务从事不法交易行为，包括但不限于洗钱、贩卖枪支、毒品、禁药、盗版软件、黄色淫秽物品及其他监管机构、司法机构等认为不得使用领易付提供的服务进行交易的行为等。</p>
      <p class="text tab-2">（5）您利用领易付进行套现。</p>
      <p class="text tab-2">（6）您从事任何可能侵害领易付或平台系统的行为。</p>
      <p class="text tab-2">（7）您违反任何法律法规、监管政策或本协议的各项规则的。</p>
      <p class="text tab-2"><b>十二、其他</b></p>
      <p class="text tab-2">12.1如因不可抗力或其它无法控制的原因使本站活动服务无法及时提供或无法按本协议进行的，领易付会合理地尽力协助处理善后事宜。</p>
      <p class="text tab-2">12.2如您对本协议或使用会员礼包服务的过程中有任何问题（包括问题咨询、投诉等），领易付为您提供如下反馈通道，希望为您提供满意的解决方案：</p>
      <p class="text tab-2">专设的邮件通道：领易付专门设立了 邮箱，您可以通过该邮箱与领易付联系。</p>
      <p class="text tab-2">领易付会在收到您的反馈后尽快向您答复。</p>
      <p class="text tab-2">12.3 涉及合作服务方提供的会员服务相关内容的，用户应同时遵守合作服务方的相关条款。 </p>
      <p class="text tab-2">附件协议：</p>
      <p class="text tab-2">附件一：<a class="link" href="https://download-cos.yofish.com/cooperator-shenghuozhibei/20230831154558902-1cd357b60.html">《岫智生活权益平台权益服务协议》</a></p>
      <p class="text tab-2">附件二：<router-link to="/protocol/auth-jw" class="link">《个人信息使用授权书》</router-link></p>
    
      <p style="padding-bottom:40px">&nbsp;</p>
    </section>
  </div>
</template>

<script>

export default {
  name: 'vipProtocol',
  created () {
    this.$bus.$emit('ready')
  }
  
}

</script>

<style lang="less">
@import "../../assets/less/mixin.less";

    .login-protocol {
        background-color: white;
        .link {
            color: #007AFF;
        }
        .content {
            padding: 0 48px;
            .title {
                font-weight: bolder;
                color: #333333;
                font-size: 28px;
                text-indent: 40px;
                line-height: 44px;
                margin-top: 10px;
            }
            .text {
                color: #333333;
                font-size: 28px;
                text-indent: 40px;
                line-height: 44px;
            }
            .text:last-child {
                margin-bottom: 10px;
            }
            .underline {
                text-indent: 40px;
                font-weight: bold;
                text-decoration: underline;
            }
            .underline:last-child {
                margin-bottom: 10px;
            }
        }
    }
</style>
